import React from "react";
import HeaderSection from "./HeaderSection";
import IllustrationSection from "./IllustrationSection";
import { motion } from "framer-motion";
import bgImg from "../../../images/bgImg.png";

const SectionTwo = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -100 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
      className="min-h-screen flex items-center justify-center"
    >
      <div
        className="w-full mt-24 p-6 relative overflow-hidden"
        style={{
          backgroundImage: `url(${bgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Main Content */}
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 relative z-10">
          {/* Left Side - HeaderSection */}
          <div className="w-full md:w-1/2 flex justify-center">
            <HeaderSection />
          </div>

          {/* Right Side - IllustrationSection */}
          <div className="w-full md:w-1/2 flex justify-center">
            <IllustrationSection />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SectionTwo;